module.exports = __webpack_public_path__ + "img/shenqing2.1a8b4c98.jpg";